import { PresetPaginationProps } from '@procore/core-react/dist/_typedoc/Pagination/Pagination.types.json';
import * as React from 'react';
export default {
  PresetPaginationProps,
  React
};